import React from 'react';
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import {toggleUseFabricatorCostPrices} from "../../actions/actionFunctions";
import Analytics from "../../analytics";

const FabricatorCostSwitcher = (props) => {

  const {fabricatorData, toggleUseFabricatorCostPrices, shopPageOpened, intl} = props;
  const fabricatorSettings = fabricatorData.settings;

  const allowedForEmployee = Array.isArray(document.dashboardUserPermissions)
    && document.dashboardUserPermissions.some(permission => {
      return permission.ProtectedAreaId === 9002 && permission.AccessRights !== 0
    }); // Show Cost Toggle and Cost Receipts

  const bannedForEmployee = Array.isArray(document.dashboardUserPermissions)
    && document.dashboardUserPermissions.some(permission => {
    return permission.ProtectedAreaId === 9002 && permission.AccessRights === 0
  }); // Show Cost Toggle and Cost Receipts

  if (bannedForEmployee) {
    return null
  }

  if (!document.kvConfig.isBackend || (!fabricatorData.showCostPricesToggle && !allowedForEmployee)) {
    return null
  }

  const handleButtonClick = () => {
    Analytics.sendClickEvent(`toggle-use-fab-prices-${!fabricatorSettings.useFabricatorCostPrices ? "on" : "off"}`);
    toggleUseFabricatorCostPrices(!fabricatorSettings.useFabricatorCostPrices);
  };

  if (shopPageOpened) {
    return (
      <FormControlLabel
        label={intl.formatMessage({id: "header.costPrices"})}
        className="u-m-0"
        control={
          <Switch
            checked={fabricatorSettings.useFabricatorCostPrices}
            className={"gm-ios-checkbox gm-ios-checkbox--small"}
            disableRipple
            onChange={handleButtonClick}
            color="primary"
          />
        }
      />
    )
  }

  return (
    <div className="ui-radio-block">
      <span className="ui-radio-label"><FormattedMessage id="header.costPrices"/></span>
      <button className={"ui-radio ui-radio--small" + (fabricatorSettings.useFabricatorCostPrices ? " ui-radio--checked" : "")}
              onClick={handleButtonClick}>
        <span className="ui-radio-circle"/>
        <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
        <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
      </button>
    </div>
  )
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  const {showAssignQuotePopup} = store.assignQuoteState;
  const {shopPageOpened} = store.shopState;
  return {
    fabricatorData,
    showAssignQuotePopup,
    shopPageOpened,
  };
};

const mapDispatchToProps = {
  toggleUseFabricatorCostPrices,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(
  React.memo(FabricatorCostSwitcher, (props, nextProps)=> {
    // if (props.showAssignQuotePopup === nextProps.prop1) {
    if (nextProps.showAssignQuotePopup) {
      // don't re-render/update
      return true
    }
  })
));
